import { useAuth } from './auth/AuthProvider';
import { useRole } from '../hooks/useRole';

export default function Unauthorized() {
  const { user } = useAuth();
  const { role } = useRole();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="bg-white rounded-xl shadow-xl p-8 text-center">
          <div className="text-red-600 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.96-.833-2.732 0L3.072 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          
          <div className="space-y-3 text-gray-600">
            <p>You don't have permission to access this page.</p>
            <p className="text-sm">
              <span className="font-medium">User:</span> {user?.email}
            </p>
            <p className="text-sm">
              <span className="font-medium">Current Role:</span> {role || 'None'}
            </p>
          </div>
          
          <div className="mt-6">
            <a 
              href="/dashboard" 
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Back to Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}